function validateNoteText(value = '') {
  if (value.length > 0 && !value.match(/[A-Za-z0-9]/)) {
    return 'Note needs at least one alphanumeric character.';
  }
  return '';
}

export default validateNoteText;
